import { Form, FormItemProps as AntdFormItemProps } from 'antd'
import CategoryInfo from './CategoryInfo'
import { HeadingLevel, TextLevel } from '@lmc/ui-kit'

export interface FormItemProps<Values> extends AntdFormItemProps<Values> {
  description?: string
  titleLevel?: HeadingLevel
  descriptionLevel?: TextLevel
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint
const FormItem = <Values extends any = any>(props: FormItemProps<Values>) => {
  const {
    children,
    label,
    description,
    required,
    titleLevel,
    descriptionLevel,
    ...restProps
  } = props

  return (
    <CategoryInfo
      title={label}
      required={required}
      description={description}
      titleLevel={titleLevel}
      descriptionLevel={descriptionLevel}
    >
      <Form.Item<Values> required={required} {...restProps} data-cy="form-item">
        {children}
      </Form.Item>
    </CategoryInfo>
  )
}

export default FormItem
